import { defaultTeamMetricsSettings } from "src/components";
import { ITeamMetricsSettings, useSettings } from "src/hooks";

const useTeamMetricsSettings = (teamSlug: string) => {
  const {
    teamMetricsSettings: { [teamSlug]: unsafeSettings },
    updateTeamMetricsSettings,
  } = useSettings();

  const safeSettings: ITeamMetricsSettings = {
    ...defaultTeamMetricsSettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<ITeamMetricsSettings>) => {
      updateTeamMetricsSettings(teamSlug, updatedSettings);
    },
  };
};

export { useTeamMetricsSettings };
